import React from "react";
import { useAtom } from "jotai";
import {
  openedDocItemAtom,
  selectedDocumentTypeAtom,
} from "atoms/documentsAtom";
import useDocuments from "features/Documents/useDocuments";
import { useDocReferenceData } from "features/Documents/useDocReferenceData";

import { Button } from "components/Button";
import {
  ModalShell,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "components/Modal";

import { DocItemForm } from "./DocItemForm";
import styles from "./styles.module.scss";

/** Модалка позиции документа (создание/редактирование товара в документе) */
export const DocItemModal = () => {
  const { saveDocItem, closeDocItemModal } = useDocuments();
  const referenceData = useDocReferenceData();
  const [openedDocItem] = useAtom(openedDocItemAtom);
  const [selectedDocumentType] = useAtom(selectedDocumentTypeAtom);

  if (!selectedDocumentType?.id) return null;

  return (
    <ModalShell className={styles.modal}>
      <ModalHeader
        title={
          openedDocItem ? `Товар № "${openedDocItem.index}"` : "Новый товар"
        }
        onClose={closeDocItemModal}
      />
      <ModalBody>
        <DocItemForm
          docType={selectedDocumentType.id}
          referenceData={referenceData}
        />
      </ModalBody>
      <ModalFooter align="start">
        <Button
          icon="galochka"
          variant="secondary"
          onClick={() => saveDocItem(referenceData)}
        >
          Сохранить
        </Button>
        <Button variant="tertiary" onClick={closeDocItemModal}>
          Отмена
        </Button>
      </ModalFooter>
    </ModalShell>
  );
};
